import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './UserAdd.module.css'
import Plus from "../../../../assets/Icon/Plus";
import At from "../../../../assets/Icon/At";
import Id from "../../../../assets/Icon/Id";
import Lock from "../../../../assets/Icon/Lock";
import User from "../../../../assets/Icon/User";
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle';
import Select from "react-select";
import Form from '../../../../assets/Style/Form.module.css'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { useTranslation } from 'react-i18next';
import RoleLanguage from '../../../UI/RoleLanguage/RoleLanguage';  

const AddUserModal = ({ userService, defaultUser }) => {
    const {t} = useTranslation();
    
    const userResetData = {
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        password: "",
        mobile: "",
        role_id: 0,
        saler_id: 0,
        salary: 0,
        bonus_percent: 0,
        bonus_max_percent: 0,
        level: 0,
        companyName: "",
        companyIdentifier: "" 
    }

 


    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };

    const [newUser, setNewUser] = useState(userResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})
    const [isCompany, setIsCompany] = useState(false);

    const { appState, app } = useContext(AppContext);
    var roles = appState.roles.map((role) => ({ value: role.id,  label: <RoleLanguage role={role.description} />
 }));

    const findRoleIdByName = (name) => {
        const role = appState.roles.find(role => role.name === name);
        return role ? role.id : 0;
    }

    const findRoleByName = (name) => {
        const role = appState.roles.find(role => role.name === name);
        return role ? role : null;
    }

    const superAdminRoleId = findRoleIdByName("superadmin");
    const adminRoleId = findRoleIdByName("administrator");
    const clientRoleId = findRoleIdByName("client");
    const salerRoleId = findRoleIdByName("saler");
    const dealerRoleId = findRoleIdByName("dealer");
    const canShowUsers = app.hasPermission("USER_PAGE_SHOW");
    const isOwnDealerRegistration = app.hasPermission("USER_DEALER_REGISTER_OWN") && !canShowUsers;
    const currentSalerOption = appState.user ? [{
        value: appState.user.id,
        label: `${appState.user.firstname} ${appState.user.lastname}`
    }] : [];
    const salers = isOwnDealerRegistration
        ? currentSalerOption
        : appState.salers.map((saler) => ({ value: saler.id, label: `${saler.firstname} ${saler.lastname}` }));

    const resetUserData = () => ({
        ...userResetData,
        role_id: isOwnDealerRegistration ? dealerRoleId : 0,
        saler_id: isOwnDealerRegistration ? (appState.user?.id || 0) : 0,
        salary: 0,
        bonus_percent: 0,
        bonus_max_percent: 0,
        level: 0
    });

    const handleIsCompanyChange = (event) => {
        setIsCompany(event.target.checked);
        setNewUser({
            ...newUser,
            firstname: "",
            lastname: "",
            personal: "",
            companyName: "",
            companyIdentifier: ""
        });
    };
    
    const validateUser = (user) => {
        const messages = {};
    
        if (isCompany) {
            if (user.companyName.length < 2) {
                messages.companyName = { message: t('EnterCompanyName'), isValid: false };
            }
    
            if (user.companyIdentifier.length < 1) {
                messages.companyIdentifier = { message: t('Required'), isValid: false };
            }
        } else {
            if (user.firstname.length < 2) {
                messages.firstname = { message: t('PleaseEnterFirstname'), isValid: false };
            }
    
            if (user.lastname.length < 2) {
                messages.lastname = { message: t('PleaseEnterLastname'), isValid: false };
            }
    
            if (user.personal.length < 1) {
                messages.personal = { message: t('Required'), isValid: false };
            }
        }
    
        if (user.mobile.length < 13) {
            messages.mobile = { message: t('Phone12DigitsRequired'), isValid: false };
        }
    
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!user.email || user.email.length === 0 || !emailRegex.test(user.email)) {
            messages.email = { message: t('InvalidEmail'), isValid: false };
        }
    
        if (user.password.length < 6) {
            messages.password = { message: t('Password6CharsMinimum'), isValid: false };
        }
    
        if (user.role_id < 1) {
            messages.role_id = { message: t('Required'), isValid: false };
        }
    
        if (user.role_id === dealerRoleId) {
            if (user.saler_id < 1) {
                messages.saler_id = { message: t('Required'), isValid: false };
            }
        }
    
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;
    };
    const reValidate = () => {
        const isValidate = validateUser(newUser)

    }

    const [isModalOpen, setIsModalOpen] = useState(false);


    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateUser(newUser)
        }
    }, [newUser, isFirstValidated]);

    useEffect(() => {
        if (isOwnDealerRegistration) {
            setNewUser(prevState => ({
                ...prevState,
                role_id: dealerRoleId,
                saler_id: appState.user?.id || 0,
                salary: 0,
                bonus_percent: 0,
                bonus_max_percent: 0
            }));
        }
    }, [isOwnDealerRegistration, dealerRoleId, appState.user?.id]);

    


    if (isOwnDealerRegistration) {
      var ownDealerRole = findRoleByName("dealer");
      roles = ownDealerRole ? [{ value: ownDealerRole.id, label: <RoleLanguage role={ownDealerRole.description} /> }] : [];
    } else if(!app.hasPermission("ALL_ROLES_GRANT")) {
      var newRoles = []

      if (app.hasPermission("DEALER_ROLE_GRANT")) {
          var dealerRole = findRoleByName("dealer")

          if (dealerRole) {
            newRoles.push(dealerRole);
          }
      }

      if (app.hasPermission("CLIENT_ROLE_GRANT")) {
        var clientRole = findRoleByName("client")

        if (clientRole) {
          newRoles.push(clientRole);
        }
      }

      if (app.hasPermission("OPERATOR_ROLE_GRANT")) {
        var operatorRole = findRoleByName("operator")

        if (operatorRole) {
          newRoles.push(operatorRole);
        }
      }


      if (app.hasPermission("ADMINISTRATOR_ROLE_GRANT")) {
        var administratorRole = findRoleByName("administrator")

        if (administratorRole) {
          newRoles.push(administratorRole);
        }
      }


      if (app.hasPermission("SALER_ROLE_GRANT")) {
        var salerRole = findRoleByName("saler")

        if (salerRole) {
          newRoles.push(salerRole);
        }
      }

      if (app.hasPermission("SUPERADMIN_ROLE_GRANT")) {
        var superadmin = findRoleByName("superadmin")

        if (superadmin) {
          newRoles.push(superadmin);
        }
      }


      roles = newRoles.map((role) => ({ value: role.id, label: role.description }))
    }     


    const saveHandle = () => {
        const isValidate = validateUser(newUser);
    
        if (isValidate) {
            let userForAdd = { ...newUser };
    
            if (isCompany) {
                // Remove individual fields for company
                delete userForAdd.firstname;
                delete userForAdd.lastname;
                delete userForAdd.personal;
            } else {
                // Remove company fields for individual
                delete userForAdd.companyName;
                delete userForAdd.companyIdentifier;
            }
    
            if (isOwnDealerRegistration) {
                userForAdd = {
                    ...userForAdd,
                    role_id: dealerRoleId,
                    saler_id: appState.user?.id || 0,
                    salary: 0,
                    bonus_percent: 0,
                    bonus_max_percent: 0
                };
            }

            if (dealerRoleId !== userForAdd.role_id) {
                delete userForAdd.saler_id;
            }
    
            if ((adminRoleId !== userForAdd.role_id) && (salerRoleId !== userForAdd.role_id)) {
                userForAdd = {
                    ...userForAdd,
                    salary: 0,
                    bonus_percent: 0,
                    bonus_max_percent: 0
                };
            }
    
            userService.add(userForAdd)
                .then(data => {
                    app.setOk("მომხმარებელი წარმატებით დაემატა");
                    setIsModalOpen(false);
                })
                .catch(errorMessage => {
                    console.error('შეცდომა:', errorMessage);
                    if (errorMessage.includes("email")) {
                        app.setError("შეცდომა: ესეთი ელ-ფოსტით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("mobile")) {
                        app.setError("შეცდომა: ესეთი მობილურით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("unique vin")) {
                        app.setError("შეცდომა: ესეთი VIN უკვე არსებობს");
                    } else {
                        app.setError("შეცდომა: " + errorMessage);
                    }
                });
        } else {
            setIsFirstValidated(true);
        }
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewUser(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const handlePhoneChange = (phone) => {
        let val = phone;
        setNewUser(prevClient => ({
            ...prevClient,
            ["mobile"]: val
        }));
 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
        setNewUser(resetUserData())
    }

    const setIsAdmin = (isAdmin) => {
        setNewUser(prevClient => ({
            ...prevClient,
            is_admin: isAdmin
        }));
    }

    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}>
                <span className={cl.icon} > <Plus /></span>
                {t('AddUser')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Plus /></span> {t('AddUser')}
                    </h3>
                </div>

                {!isCompany ? (
                    <>
                        <div className={cl.inp2col}>
                            <div className={cl.groupInput}>
                                <div className={cl.groupInputIcon}>
                                    <input
                                        type="textS"
                                        className={validates && validates.firstname ? cl.input + ' ' + cl.errorInput : cl.input}
                                        placeholder={t('Firstname')}
                                        name="firstname"
                                        value={newUser.firstname}
                                        onChange={handleClientChange}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                        }}
                                        autoComplete="off"
                                    />
                                    <div className={cl.crmIcon}>
                                        <User />
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupInput}>
                                <div className={cl.groupInputIcon}>
                                    <input
                                        type="textS"
                                        className={validates && validates.lastname ? cl.input + ' ' + cl.errorInput : cl.input}
                                        placeholder={t('Lastname')}
                                        name="lastname"
                                        value={newUser.lastname}
                                        onChange={handleClientChange}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                        }}
                                        autoComplete="off"
                                    />
                                    <div className={cl.crmIcon}>
                                        <User />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input
                                    type="textS"
                                    className={validates && validates.personal ? cl.input + ' ' + cl.errorInput : cl.input}
                                    placeholder={t('PersonalNumber')}
                                    name="personal"
                                    value={newUser.personal}
                                    onChange={handleClientChange}
                                    onInput={(e) => {
                                        if (e.target.value.length > 11) {
                                            e.target.value = e.target.value.substring(0, 11);
                                        }
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                    }}
                                    autoComplete="off"
                                />
                                <div className={cl.crmIcon}>
                                    <Id />
                                </div>
                            </div>
                            {validates && validates.personal &&
                                <div className={cl.errorMsg}>{validates.personal.message}</div>}
                        </div>
                    </>
                ) : (
                    <>
                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input
                                    type="textS"
                                    className={validates && validates.companyName ? cl.input + ' ' + cl.errorInput : cl.input}
                                    placeholder={t('CompanyName')}
                                    name="companyName"
                                    value={newUser.companyName}
                                    onChange={handleClientChange}
                                    autoComplete="off"
                                />
                                <div className={cl.crmIcon}>
                                    <User />
                                </div>
                            </div>
                            {validates && validates.companyName &&
                                <div className={cl.errorMsg}>{validates.companyName.message}</div>}
                        </div>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input
                                    type="textS"
                                    className={validates && validates.companyIdentifier ? cl.input + ' ' + cl.errorInput : cl.input}
                                    placeholder={t('CompanyIdentifier')}
                                    name="companyIdentifier"
                                    value={newUser.companyIdentifier}
                                    onChange={handleClientChange}
                                    autoComplete="off"
                                />
                                <div className={cl.crmIcon}>
                                    <Id />
                                </div>
                            </div>
                            {validates && validates.companyIdentifier &&
                                <div className={cl.errorMsg}>{validates.companyIdentifier.message}</div>}
                        </div>
                    </>
                )}


                <div className={cl.inp2col2} style={{ marginBottom: 0 }}> 
                    <div className={validates && validates.mobile ? cl.groupInput + ' errorInput'  : cl.groupInput}>
                        <PhoneInput
                            defaultCountry="ge"
                            value={newUser.mobile}
                            defaultMask="... ...-..."
                            hideDropdown={false}
                            name="mobile"  
                            onChange={(phone) => handlePhoneChange(phone)}
                        />
                            
                    {validates && validates.mobile &&
                        <div className={cl.errorMsg} >{validates.mobile.message}</div>}

                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.email ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder={t('Email')}
                                name="email" 
                                value={newUser.email} 
                                onChange={handleClientChange} 
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9.@\-_]/g, '').toUpperCase();
                                }} 
                                autoComplete="off"
                                />
                            <div className={cl.crmIcon}><At /></div>
                        </div>
                        {validates && validates.email &&
                            <div className={cl.errorMsg} >{validates.email.message}</div>}

                    </div>

                </div>




                <div className={cl.groupInput}>
                    <label style={validates && validates.role_id ? { color: 'rgb(225, 29, 72)' } : []} >{t('Role')}</label> 
                    <Select
                        styles={validates && validates.role_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={roles}
                        placeholder={t('Role')}
                        value={roles.find(option => option.value === newUser.role_id)}
                        onChange={(selectedOption) => {
                            if (isOwnDealerRegistration) {
                                return;
                            }
                            setNewUser(prevState => ({
                                ...prevState,
                                role_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                        isDisabled={isOwnDealerRegistration}
                        isClearable={!isOwnDealerRegistration}
                    />
                </div>
 

                {
                    (adminRoleId === newUser.role_id || salerRoleId === newUser.role_id) && newUser.role_id > 0 &&
                    <>
                        <div className={cl.groupPrice}>
                            <label className={cl.leftLabel}>{t('Salary')}</label>
                            <div className={cl.rightInput}>
                                <div className={Form.priceInput}>
                                    <div className={Form.priceCurrency}>
                                        GEL
                                    </div>
                                    <input type="text" name="salary" className={Form.input} value={newUser.salary} onChange={handleClientChange} min="0" />
                                    <div className={Form.hundred} >.00</div>
                                </div>
                            </div>
                        </div>

                        <div className={cl.groupPrice}>
                            <label className={cl.leftLabel}>{t('Bonus')}</label>
                            <div className={cl.rightInput}>
                                <div className={Form.priceInput}>
                                    <div className={Form.priceCurrency}>
                                        %
                                    </div>
                                    <input type="text" name="bonus_percent" className={Form.input} value={newUser.bonus_percent} onChange={handleClientChange} min="0" />
                                    <div className={Form.hundred} >.00</div>
                                </div>
                            </div>
                        </div>

                        <div className={cl.groupPrice} style={{ marginBottom: 10}}>
                            <label className={cl.leftLabel}>Max {t('Bonus')}</label>
                            <div className={cl.rightInput}>
                                <div className={Form.priceInput}>
                                    <div className={Form.priceCurrency}>
                                        %
                                    </div>
                                    <input type="text" name="bonus_max_percent" className={Form.input} value={newUser.bonus_max_percent} onChange={handleClientChange} min="0" />
                                    <div className={Form.hundred} >.00</div>
                                </div>
                            </div>
                        </div>
                    </>
                }



                {dealerRoleId === newUser.role_id && (isCompany || isOwnDealerRegistration) &&
                    <>
                        <div className={cl.groupInput}>
                            <label>{t('Saler')}</label>
                            <Select
                                styles={validates && validates.saler_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                options={salers}
                                placeholder={ t('Saler')}
                                value={salers.find(option => option.value === newUser.saler_id)}
                                onChange={(selectedOption) => {
                                    setNewUser(prevState => ({
                                        ...prevState,
                                        saler_id: selectedOption ? selectedOption.value : 0,
                                    }));
                                }}
                                isDisabled={isOwnDealerRegistration}
                            />
                        </div>
                    </>
                }

                {dealerRoleId === newUser.role_id &&
                    <div className={cl.groupInput}>
                        <label>{t('Level')}</label>
                        <Select
                            styles={selectStyle}
                            options={[
                                { value: 0, label: "0" },
                                { value: 1, label: "1" },
                                { value: 2, label: "2" },
                                { value: 3, label: "3" },
                                { value: 4, label: "4" },
                                { value: 5, label: "5" }
                            ]}
                            placeholder={t('Level')}
                            value={{
                                value: newUser.level,
                                label: newUser.level?.toString?.() || ''
                            }}
                            onChange={(selectedOption) => {
                                setNewUser(prevState => ({
                                    ...prevState,
                                    level: selectedOption ? selectedOption.value : 0
                                }));
                            }}
                        />
                    </div>
                }



                <div className={cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS" className={validates && validates.password ? cl.input + ' ' + cl.errorInput : cl.input}
                            placeholder={t('Password')} name="password" value={newUser.password} onChange={handleClientChange} autoComplete="off" />
                        <div className={cl.crmIcon}><Lock /></div>
                    </div>
                    {validates && validates.password &&
                        <div className={cl.errorMsg} >{validates.password.message}</div>}
                </div>

                <div className={cl.groupInput}>
                    <label>
                        <input
                            type="checkbox"
                            checked={isCompany}
                            onChange={handleIsCompanyChange}
                        />
                        <b>{t('Company')}</b>
                    </label>
                </div>
 
                <button onClick={saveHandle} className={cl.btnPrimary}>{t('Add')}</button>
            
            </Modal>
        </div>
    );
};

export default AddUserModal;
